module.exports = __webpack_public_path__ + "static/media/idhifa-background-image-2.ab72ea2a.png";